import { useContext } from "react";
import { PatientSubscription } from "src/api/types";
import { SubscriptionContext } from "./SubscriptionProvider";

export function useSubscription<T>(
  selector: (subscription: PatientSubscription) => T
) {
  const subscription = useContext(SubscriptionContext);

  if (subscription == null) {
    return null;
  }

  return selector(subscription);
}
